module.exports={
	"Form": "PayItemCreateManifest",
	"Scope": "PayItem-Create",
	"Descriptors":
	{
		"PayItemDetails.Name":
		{
			"Name": "Name",
			"Hash": "PayItem-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "PayItem-Create-Identity",
				"Group": "PayItem-Create-Identity"
			}
		},
		"PayItemDetails.ItemCode":
		{
			"Name": "Item Code",
			"Hash": "PayItem-Create-ItemCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "PayItem-Create-Identity",
				"Group": "PayItem-Create-Identity"
			}
		},
		"PayItemDetails.Description":
		{
			"Name": "Description",
			"Hash": "PayItem-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "PayItem-Create-Details",
				"Group": "PayItem-Create-Details"
			}
		},
		"PayItemDetails.FunctionalClass":
		{
			"Name": "Functional Class",
			"Hash": "PayItem-Create-FunctionalClass",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "PayItem-Create-Details",
				"Group": "PayItem-Create-Details"
			}
		},
		"PayItemDetails.Units":
		{
			"Name": "Units",
			"Hash": "PayItem-Create-Units",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "PayItem-Create-Details",
				"Group": "PayItem-Create-Details"
			}
		},
		"PayItemDetails.Amount":
		{
			"Name": "Amount",
			"Hash": "PayItem-Create-Amount",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "PayItem-Create-Details",
				"Group": "PayItem-Create-Details"
			}
		},
		"PayItemDetails.SpecificationYear":
		{
			"Name": "Specification Year",
			"Hash": "PayItem-Create-SpecificationYear",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "PayItem-Create-Details",
				"Group": "PayItem-Create-Details"
			}
		},
		"PayItemDetails.IDTestSpecificationSet":
		{
			"Name": "Test Specification Set",
			"Hash": "PayItem-Create-IDTestSpecificationSet",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "PayItem-Create-Details",
				"Group": "PayItem-Create-Details",
				"Entity": "TestSpecificationSet",
				"SearchFields":
				[
					"Name"
				]
			}
		},
		"PayItemDetails.Section":
		{
			"Name": "Section",
			"Hash": "PayItem-Create-Section",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "PayItem-Create-Details",
				"Group": "PayItem-Create-Details"
			}
		},
		"PayItemDetails.ExternalPayItemID":
		{
			"Name": "External Pay Item ID",
			"Hash": "PayItem-Create-ExternalPayItemID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "PayItem-Create-Details",
				"Group": "PayItem-Create-Details"
			}
		},
		"PayItemDetails.FHWAEligible":
		{
			"Name": "FHWAEligible",
			"Hash": "PayItem-Create-FHWAEligible",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "5",
				"Width": 3,
				"Section": "PayItem-Create-Details",
				"Group": "PayItem-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "PayItem-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "PayItem-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "PayItem-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "PayItem-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
